import { useContext } from "react";

import { PincodeContext } from "../contexts/PincodeContext";
// import { AuthContext } from "../contexts/FirebaseAuthContext";
// import { AuthContext } from "../contexts/Auth0Context";
// import { AuthContext } from "../contexts/CognitoContext";

const usePincode = () => {
  const context = useContext(PincodeContext);

  if (!context) throw new Error("PincodeContext must be placed within PincodeProvider");

  return context;
};

export default usePincode;
